"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_1 = require("./app");
const responseError = require("./common/responseError");
function addStudentStateDoc({ studentId, state = {} }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const data = {
                studentId,
                state
            };
            const docRef = yield app_1.app.firestore.collection(`studentStates`).add(data);
            console.log('Document written with ID: ', docRef.id);
            return Object.assign({ id: docRef.id }, data);
        }
        catch (e) {
            throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, e.message);
        }
    });
}
exports.default = addStudentStateDoc;
//# sourceMappingURL=addStudentState.js.map